import React, {useState} from 'react';
import styles from './item.module.scss';
import {Accordion} from "react-bootstrap";

type Props = {
  show: boolean,
  key?: number,
  faq: IFAQItem
};

const FAQItem: React.FC<Props> = ({ faq, show }) => {
  const [open, setOpen] = useState<boolean>(show);
  return (
    <div className={styles.FAQItem + (open ? ' ' + styles.open : '')}>
      <div className={styles.accordion}>
        <h3 className={styles.header} onClick={() => setOpen(o=>!o)}>{faq.question}</h3>
        <p className={styles.body}>
          {faq.answer}
        </p>
      </div>
    </div>
  );
}

export default FAQItem;
